// Phone utilities shared across components

// Format for display: accepts raw like 78888888888 or any string; returns 
// +7 (XXX) XXX-XX-XX when possible, otherwise returns original input.
export function formatPhoneDisplay(phone?: string | null): string {
  if (!phone) return '';
  const numbers = String(phone).replace(/\D/g, '');
  if (numbers.length === 11 && numbers.startsWith('7')) {
    const d = numbers.slice(1);
    const m = d.match(/^(\d{3})(\d{3})(\d{2})(\d{2})$/);
    if (m) return `+7 (${m[1]}) ${m[2]}-${m[3]}-${m[4]}`;
  }
  return String(phone);
}

// Format while typing in an input: forces leading 7 and groups as +7 (XXX) XXX-XX-XX
export function formatPhoneInput(value: string): string {
  let numbers = String(value).replace(/\D/g, '');
  if (numbers.length > 0) {
    if (!numbers.startsWith('7')) numbers = '7' + numbers.slice(1);
    const digits = numbers.slice(1).substring(0, 10);
    const m = digits.match(/^(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})$/);
    if (m) {
      const parts: string[] = ['+7'];
      if (m[1]) parts.push(` (${m[1]}`);
      if (m[2]) parts.push(m[1].length === 3 ? `) ${m[2]}` : m[2]);
      if (m[3]) parts.push(`-${m[3]}`);
      if (m[4]) parts.push(`-${m[4]}`);
      return parts.join('');
    }
  }
  return value;
}

// Normalize for API: returns only digits starting with 7 (e.g., 79991234567) or null if empty
export function normalizePhoneDigits(value?: string | null): string | null {
  const digits = (value || '').replace(/\D/g, '');
  if (!digits) return null;

  // Если номер начинается с 7 (КЗ/РУ) - возвращаем как есть
  if (digits.startsWith('7')) return digits;

  // Если номер из 11 цифр и начинается с 8 - это КЗ/РУ номер с неправильным кодом, меняем 8 на 7
  if (digits.length === 11 && digits.startsWith('8')) {
    return '7' + digits.substring(1);
  }

  // Если номер из 11 цифр и начинается с 9 (но НЕ с 90) - это КЗ/РУ номер, меняем 9 на 7
  if (digits.length === 11 && digits.startsWith('9') && !digits.startsWith('90')) {
    return '7' + digits.substring(1);
  }

  // Если номер начинается с 90 (Турция) или другие международные форматы - оставляем как есть
  if (digits.startsWith('90') || digits.length > 11) {
    return digits;
  }

  // Если номер из 10 цифр - это КЗ/РУ номер без кода страны, добавляем 7
  if (digits.length === 10) {
    return '7' + digits;
  }

  // Fallback: возвращаем как есть
  return digits;
}

